import { ModalInstance, ModalInstanceOptions } from './types';

export const createModalInstance = <TPayload extends object>(
	id: string,
	options?: ModalInstanceOptions
): ModalInstance<TPayload> => ({ id, options });
